import React from 'react';

type FieldWithIconProps = {
  icon: string;
  label: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  className?: string;
  readOnly?: boolean;
};

const FieldWithIcon: React.FC<FieldWithIconProps> = ({
  icon,
  label,
  value,
  placeholder,
  onChange,
  className,
  readOnly,
}) => (
  <label
    className={`flex min-w-0 items-center gap-2 rounded border border-[#33456f] bg-[#0a1329] px-2 py-1 text-xs text-slate-100 ${className || ''}`}
  >
    <span className="shrink-0 text-sm">{icon}</span>
    <span className="shrink-0 text-[11px] text-slate-300">{label}</span>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      readOnly={readOnly}
      className="min-w-0 flex-1 bg-transparent text-xs text-slate-100 placeholder:text-slate-500 focus:outline-none"
    />
  </label>
);

export default FieldWithIcon;
